var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.25C22 15.6359 17.0761 20 11.0006 20C9.40659 20 7.89418 19.7 6.52785 19.1609C6.01655 19.5688 5.18301 20.1266 4.19478 20.5953C3.16359 21.0828 1.92187 21.5 0.688734 21.5C0.409454 21.5 0.160249 21.3172 0.0528337 21.0359C-0.054582 20.7547 0.00557079 20.4359 0.198919 20.2203L0.211809 20.2062C0.224699 20.1922 0.241885 20.1734 0.267665 20.1406C0.314928 20.0844 0.387971 19.9953 0.4782 19.8734C0.654361 19.6391 0.890676 19.2922 1.13129 18.8609C1.56095 18.0828 1.96913 17.0609 2.05076 15.9125C0.761777 14.3187 0.00127417 12.3641 0.00127417 10.25C0.00127417 4.86406 4.92521 0.5 11.0006 0.5C17.0761 0.5 22 4.86406 22 10.25Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSolid);
export default __webpack_public_path__ + "static/media/comment-solid.e611e57095c01d614d5c9d9e53e74ff3.svg";
export { ForwardRef as ReactComponent };